import { FiMail } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import useReveal from './useReveal';
import emran from '../assets/me.jpg';
import natnael from '../assets/me9.jpg';
import milkiy from '../assets/me6.jpg';
import amir from '../assets/me8.jpg';
import alazar from '../assets/me13.jpg';
import sofonias from '../assets/me14.jpg';

const members = [
  { name: 'Emran Hayredin', role: 'Co-founder and CEO', email: 'imran@minatechnologies.com', photo: emran },
  { name: 'Alazar Damena', role: 'Co-founder and Head of Development', email: 'alazar@minatechnologies.com', photo: alazar },
  { name: 'Natnael Mengistu', role: 'CTO', email: 'natnael@minatechnologies.com', photo: natnael },
  { name: 'Milkiy Mohammed', role: 'Co-founder and UI/UX Lead', email: 'milky@minatechnologies.com', photo: milkiy },
  { name: 'Sofonias Birhanu', role: 'Co-founder and Head of Business Development', email: 'sofonias@minatechnologies.com', photo: sofonias },
  { name: 'Amir Hayredin', role: 'Marketing Manager', email: 'amir@minatechnologies.com', photo: amir },
];

function Teams() {
  const ref = useReveal();

  return (
    <div ref={ref} className="section-pad bg-surface">
      <div className="wrap">
        <SectionHeading
          eyebrow="Our team"
          title={<>Meet the <span className="text-gradient">leaders</span></>}
          lede="A small, senior team of engineers, designers and strategists who own your project from first call to launch."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {members.map((member, index) => (
            <article
              key={member.email}
              className="reveal card card-lift group p-3"
              data-reveal
              style={{ '--d': `${(index % 3) * 80}ms` }}
            >
              <div className="overflow-hidden rounded-media bg-surface-2">
                <img
                  src={member.photo}
                  alt={member.name}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="flex items-center justify-between gap-4 px-2 pb-1 pt-4">
                <div className="min-w-0">
                  <h3 className="font-display text-lg font-semibold text-ink">{member.name}</h3>
                  <p className="text-sm text-muted">{member.role}</p>
                </div>
                <a href={`mailto:${member.email}`} className="btn-icon" aria-label={`Email ${member.name}`}>
                  <FiMail />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Teams;
